module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "floatmenu-box"
  }, [_c('div', {
    directives: [{
      name: "fixpos",
      rawName: "v-fixpos",
      value: ({
        pos: 'right',
        default: '0.25rem'
      }),
      expression: "{ pos: 'right', default: '0.25rem' }"
    }],
    staticClass: "my-order-button"
  }, [_c('a', {
    directives: [{
      name: "burypoint",
      rawName: "v-burypoint",
      value: ({
        events: 'wddd',
        page: _vm.parentpage,
        isChildComponents: true,
        oldPropName: _vm.acceptname
      }),
      expression: "{ events: 'wddd', page: parentpage, isChildComponents: true, oldPropName: acceptname }"
    }],
    staticClass: "my-order",
    attrs: {
      "href": "/order/listbrowser.html"
    }
  }, [_vm._v("我的订单")])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "burypoint",
      rawName: "v-burypoint",
      value: ({
        events: 'gdcs',
        page: _vm.parentpage,
        isChildComponents: true,
        oldPropName: _vm.acceptname
      }),
      expression: "{ events: 'gdcs', page: parentpage, isChildComponents: true, oldPropName: acceptname }"
    }],
    staticClass: "home-index-btn",
    on: {
      "click": _vm.toHome
    }
  }, [_vm._v("更多测算")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a80cd780","hasScoped":true}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/pl_floatmenu/index.vue
// module id = LrBC
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13 14